// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/sp-nggallery/src/css/ngGallery.css
// module id = 32
// module chunks = 0